module.exports = "\r\n<div class=\"disabled\">Save Library</div>\r\n<div class=\"disabled\">Load Library</div>\r\n\r\n<div (click)=\"clearLibrary()\">\r\n\tClear Library\r\n</div>\r\n<br>\r\n<div class=\"node\" *ngFor=\"let n of _savedNodes; let i=index\"\r\n\t(click)=\"addNode($event, i)\">\r\n\t{{n._name}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/viewers/node-library/node-library.component.html
// module id = ../../../../../src/app/ui-components/viewers/node-library/node-library.component.html
// module chunks = main